// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TemplatePopup_case_template_title__jV4nM {
  padding: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/TemplatePopup/TemplatePopup.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd","sourcesContent":[".case_template_title {\n  padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"case_template_title": `TemplatePopup_case_template_title__jV4nM`
};
export default ___CSS_LOADER_EXPORT___;
